module.exports = __webpack_public_path__ + "img/bg_page.ab74a6c5.png";